import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import { potential_fixing_operation_for_selected_objects } from '../../ui_display';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import fix_tangent_at_vertex_svg from '../../../assets/img/SVG_icons/Top/create_model/anchor.svg';
import { img } from '@phi/components';
import { fix_edge_tangent_at_vertex, unfix_edge_tangent_at_vertex } from '@frontend/uid_continuity';
import FixTangentAtVertexTooltip from './FixTangentAtVertexTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const FixTangentIcon = fix_tangent_at_vertex_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Lock tangent';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                )
                || this.total_selected_objects === 0
                || !this.state.editing_edge_tangent_mode
                || potential_fixing_operation_for_selected_objects() === 'disable';
        },

        total_selected_objects() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        },

        active() {
            return this.total_selected_objects > 0
                && this.state.editing_edge_tangent_mode
                && potential_fixing_operation_for_selected_objects() === 'enable_unfixing';
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.subscriptions.state.subscription_status.value === 'starter')
                this.subscriptions.show_pro_feature_modal();
            else if (this.active)
                unfix_edge_tangent_at_vertex(0, null, null);
            else
                fix_edge_tangent_at_vertex(0, null);
        },
    },

    render() {
        return h(BarButton, {
            id: 'fix-edge-tangent-at-vertex-button',
            onClick: this.onClick,
            active: this.active,
            disabled: this.disabled,
            selected: this.state.tut_stage === 8,
            tippy: 'left',
            help: 'lock_tangent',
            pro_indicator: this.subscriptions.state.subscription_status.value === 'starter',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(fix_tangent_at_vertex_svg, this.alt),
            tooltip: FixTangentAtVertexTooltip,
        });
    },
});
